export default {
  maxNumberOfAvatarsShown: 4,
  playerInteractionTitle: 'Label.ContextMenuTitle',
  viewGameDetails: 'Action.ViewDetails',
  joinGame: 'Action.JoinGame',
  eventStreamParams: {
    goToProfileInPlacesList: {
      name: 'goToProfileInPlacesList',
      ctx: 'click'
    },
    openModalFromGameTile: {
      name: 'openModalFromGameTile',
      ctx: 'click'
    },
    goToChatInPlacesList: {
      name: 'goToChatInPlacesList',
      ctx: 'click'
    },
    joinGameInPlacesList: {
      name: 'joinGameInPlacesList',
      ctx: 'click'
    },
    goToGameDetailInPlacesList: {
      name: 'goToGameDetailInPlacesList',
      ctx: 'click'
    },
    gamePlayIntentInPlacesList: {
      ctx: 'placesListInHomePage'
    }
  }
};
